import React, { useContext, useState } from 'react'
import { M_Table, M_MessageBoard, M_Button, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'

export const ServiceTypeList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [quoteToDelete, setQuoteToDelete] = useState()
    const serviceTypeService = new BufferService('ServiceType')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        const tempPerm = []

        roles.forEach((role) => {
            if (role.match('Quote')) {
                tempPerm.push(role.split('Quote')[1])
            }
        })

        // Garantir que sempre temos linhas
        const selectedLines = selectedRows && selectedRows.length > 0
            ? selectedRows
            : (data ? [data] : [])

        ctx.passValue?.set('operation', operation)

        if (operation === 'create') {
            ctx2.newTab('go/serviceTypeDetail', t("CreateServiceType"))
            return
        }

        // VALIDAR seleção
        if (!data && selectedLines.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        // EDIT
        if (operation === 'edit') {
            ctx.passValue.set('Row', data)
            ctx.passValue.set('Rows', selectedLines)

            ctx2.newTab('go/serviceTypeDetail', t("EditServiceType"))
            return
        }
    }

    const deleteServiceType = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            deleteFunc(tempData[tempData.length - 1].Id)
            return
        }
        deleteFunc(tempData.Id)
    }

    function deleteFunc(id) {
        serviceTypeService.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessServiceTypeDeleted"))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    const removeContextItems = ['View', 'Copy']

    return (
        <div className='backgroundForms'>
            < div >
                <div>
                    <M_Table
                        roleName={'Quote'}
                        filtersOnTable
                        entityName={'ServiceType'}
                        tablesOrder={tablesOrder}
                        onTablesOrderUpdate={onTablesOrderUpdate}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        replaceFunctions={new Map([
                            ['Delete', (data) => {
                                setQuoteToDelete(data)
                                setOpenDeleteDialog(true)
                            }],
                            ['Create', (data) => NewRoute('', '', 'create', data)],
                            ['Edit', (data) => NewRoute('', '', 'edit', data)]
                        ])}
                        onPassLine={(rows) => {
                            setSelectedRows(rows)
                        }}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t("Delete")} ${t("ServiceType")}?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>{t("ServiceType")}</b>
                </span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteServiceType(quoteToDelete)}
                        />
                    </div>
                }
            />
        </div >
    )
}
